import React from 'react';
import { Segment } from 'semantic-ui-react';
import TrimmedMarkdownRender from '@/components/text-editors/TrimmedMarkdownRender';
import DatasetConditionDescription from './DatasetConditionDescription';
import UserDefinedLinkRestrictionInfo from './UserDefinedLinkRestrictionInfo';
import UserDefinedAttachmentRestrictionInfo from '../containers/UserDefinedAttachmentRestrictionInfo';
import { UserDefinedRestrictionTypes } from '../constants';

const components = {
  [UserDefinedRestrictionTypes.LINK]: UserDefinedLinkRestrictionInfo,
  [UserDefinedRestrictionTypes.ATTACHMENT]: UserDefinedAttachmentRestrictionInfo,
};

const UserDefinedRestrictionInfo = ({ datasetCondition, code }) => {
  const Component = components[datasetCondition?.context?.type];

  return (
    <>
      <DatasetConditionDescription datasetCondition={datasetCondition} />
      <Segment className="mt-0">
        {Component && <Component datasetCondition={datasetCondition} code={code} />}
        <TrimmedMarkdownRender
          maxLines={3}
          maxChars={100}
          text={datasetCondition.context.text}
          suffix={null}
          withShowMore
        />
      </Segment>
    </>
  );
};

export default UserDefinedRestrictionInfo;
